/*
 *  IGS-2302: User Segment definitions
 * */

export const PRIVATE_CUSTOMER = 'PR';
export const PERSONAL_CUSTOMER = 'P';
export const BUSINESS_CUSTOMER = 'B';
export const NOMINATED_USER = 'N';
export const ADDITIONAL_USER = 'AU';
export const CORPORATE_ADMIN = 'CA';
export const PRIVATE_USER = 'PR';
